export enum ConversationRatingQuestionCodeEnum {
  HelpfulThumbs = 'HELPFUL_THUMBS',
  ExperienceThumbs = 'EXPERIENCE_THUMBS',
  AiAgentFeedback = 'AI_AGENT_FEEDBACK',
  HelpfulWhy = 'HELPFUL_WHY',
  Feedback = 'FEEDBACK',
}

export enum ConversationRatingResponseCodeEnum {
  VeryPositive = 'VERY_POSITIVE',
  Positive = 'POSITIVE',
  Neutral = 'NEUTRAL',
  Negative = 'NEGATIVE',
  VeryNegative = 'VERY_NEGATIVE',
  Other = 'OTHER',
  Unset = 'UNSET',
}
